import React from 'react'
import { Route, Switch, useLocation, useParams } from 'react-router-dom'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { AppWrap } from 'apps/marketplace/components/AppWrap'
import { RouteNotFound } from 'components/404'
import { RedirectTo } from 'components/RedirectTo'
import { isUserType } from 'utils/userTypes'
import { UserCreate } from './UserCreate'
import { User } from './UserDetails/User/User'
import UsersListPage from './UsersList'

// TODO: Type component to avoid doing this
const UserComponent = User as any

export const appName = 'users'

export function App() {
  const { pathname } = useLocation()
  const { id } = useParams<{ id: string }>()
  const { userDetails } = useUserDetails()
  const { userType = '' } = userDetails || {}
  const isUserCreate = pathname.includes('new')
  const isAdmin = isUserType('admin', userType)

  return (
    <AppWrap
      appName={appName}
      title={isUserCreate ? 'Add New | Users' : 'User Profile'}
      noHeader={isUserCreate}
      noFooter={isUserCreate}>
      <Switch>
        <Route exact path='/'>
          <UsersListPage />
        </Route>
        <Route exact path='/new' component={UserCreate} />
        <Route
          exact
          path='/:id/:tab?'
          render={() =>
            isAdmin ? <UserComponent /> : <RedirectTo url={`${__ROOT__}/users/${id}`} />
          }
        />
        <Route component={RouteNotFound} />
      </Switch>
    </AppWrap>
  )
}

export default App
